import { IComponent } from "../../components/component.interface";
import { StringHelpers } from "../../helpers/string-helpers";
import { IChartContainer } from "../base/chart-container.interface";

export abstract class SingleStockWindowComponent implements IComponent {
    public id = StringHelpers.newGuid();
    protected element: HTMLElement;
    protected base: IChartContainer;


    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
    }

    public getClientHeight(): number {
        return this.element.clientHeight;
    }
}